import React, { useRef, useState } from "react"
import "./ShareSpaceButton.scss"
import classNames from "classnames"
import externalLinkIcon from "./external-link.svg"
import Popover from "../Popover/Popover"

type ShareSpaceButtonProps = {
  shareToken: string
  className?: string
}

export default function ShareSpaceButton({
  shareToken,
  className,
}: ShareSpaceButtonProps) {
  const [copied, setCopied] = useState(false)
  const copiedTimeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [hovered, setHovered] = useState(false)

  const handleCopy = () => {
    if (copiedTimeoutRef.current) {
      clearTimeout(copiedTimeoutRef.current)
    }
    setCopied(true)
    setHovered(false)
    navigator.clipboard.writeText(`${location.origin}/shared/${shareToken}`)

    copiedTimeoutRef.current = setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <div className={classNames("ShareSpaceButton", className)}>
      <button
        className="ShareSpaceButton__button"
        aria-label="Copy guest link"
        onClick={handleCopy}
        disabled={copied}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <img src={externalLinkIcon} />
      </button>
      <Popover shown={hovered} className="ShareSpaceButton__tooltip">
        Copy guest link
      </Popover>
      <Popover shown={copied} className="ShareSpaceButton__tooltip">
        Copied
      </Popover>
    </div>
  )
}
